<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: flex-start;">
            <el-date-picker
              v-model="table.query.needRentDate"
              type="month"
              placeholder="请选择月份"
              value-format="yyyy-MM"
              @change="search">
            </el-date-picker>
          </div>
          <div style="display: flex;justify-content: flex-end;">
            <el-button type="primary" size="small" @click="handleExcelExport"
                       icon="el-icon-download" class="ml20">导出
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="房源" align="center"
                             prop="houseName"></el-table-column>
            <el-table-column show-overflow-tooltip label="管理员" align="center"
                             prop="adminName"></el-table-column>
            <el-table-column show-overflow-tooltip label="月租金" align="center"
                             prop="rent">
              <template slot-scope="scope">
                <span v-if="scope.row.payType == 0">{{scope.row.rent}}</span>
                <span v-if="scope.row.payType == 1">{{Math.ceil(scope.row.rent)}}</span>
                <span v-if="scope.row.payType == 2">{{Math.ceil(scope.row.rent)}}</span>
                <span v-if="scope.row.payType == 3">{{Math.ceil(scope.row.rent)}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="应付租金" align="center"
                             prop="rent">
              <template slot-scope="scope">
                <span v-if="scope.row.payType == 0">{{scope.row.rent}}</span>
                <span v-if="scope.row.payType == 1">{{Math.ceil(scope.row.rent) * 3}}</span>
                <span v-if="scope.row.payType == 2">{{Math.ceil(scope.row.rent) * 6}}</span>
                <span v-if="scope.row.payType == 3">{{Math.ceil(scope.row.rent) * 12}}</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="交租日期" align="center"
                             prop="needRentDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="付款方式" align="center"
                             prop="payType">
              <template slot-scope="scope">
                <span v-if="scope.row.payType == 0">月付</span>
                <span v-if="scope.row.payType == 1">季付</span>
                <span v-if="scope.row.payType == 2">半年付</span>
                <span v-if="scope.row.payType == 3">年付</span>
              </template>
            </el-table-column>
<!--            <el-table-column show-overflow-tooltip label="合同日期" align="center"-->
<!--                             prop="contractDate">-->
<!--            </el-table-column>-->
            <el-table-column show-overflow-tooltip label="交租记录" align="center"
                             prop="state">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 0">未交租</span>
                <span v-if="scope.row.state == 1">已交租</span>
                <span v-if="scope.row.state == 2">合同结束</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {getPageList} from "@/api/ownerCollectRecord";

export default {
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          needRentDate: ''
        },
        total: 0,
        data: []
      },
      tableLoading: false
    }
  },
  mounted() {
    this.search(true)
  },
  methods: {
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        needRentDate: this.table.query.needRentDate
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    //导出
    handleExcelExport() {
      let url = "/hrApi/ownerCollectRecord/export?token=" + localStorage.getItem("token")
      if (this.table.query.needRentDate) {
        url = url + "&needRentDate=" + this.table.query.needRentDate
      }
      window.open(url);
      this.$message.success("导出成功！");
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/OwnerCollectRecordAll.vue